import { appliedReportSelectors } from './applied';
import { currentReportSelectors } from './current';

const didReportChange = (reportState) =>
    Object.keys(reportState.applied).some((key) => reportState.applied[key] !== reportState.current[key]);

export const computeReportCategory = (locationPath) => {
    if (locationPath.indexOf('skater') !== -1) {
        return 'skater';
    } else if (locationPath.indexOf('goalie') !== -1) {
        return 'goalie';
    } else if (locationPath.indexOf('team') !== -1) {
        return 'team';
    }
    return '';
};

export default {
    ...appliedReportSelectors,
    ...currentReportSelectors,
    didReportChange,
    computeReportCategory,
};
